<form [formGroup]="itemForm()">
  <div class="app-item">
    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="app-field-type"
    >
      <mat-label i18n>Select Type</mat-label>
      <mat-select
        formControlName="type"
        [panelWidth]="null"
        panelClass="app-type-panel"
        (selectionChange)="typeSelected($event.value)"
      >
        @if (itemForm().controls.type.value !== null) {
          <mat-select-trigger class="app-type-trigger">
            <mat-icon>{{ inputTypeIcons[itemForm().controls.type.value] }}</mat-icon>
            {{ inputTypes[itemForm().controls.type.value] }}
          </mat-select-trigger>
        }
        @for (type of inputTypes | keyvalue ; track type) {
        <mat-option [value]="+type.key" class="app-type-option">
          <mat-icon>{{ inputTypeIcons[+type.key] }}</mat-icon>
          {{ type.value }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (itemForm().controls.type.value !== null) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="app-field-name">
      <mat-label i18n>Name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
    <mat-checkbox formControlName="required" i18n> Required </mat-checkbox>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="app-field-tag">
      <mat-label i18n>pdf tag</mat-label>
      <input matInput formControlName="renderTag" />
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="app-field-sort">
      <mat-label i18n>Position</mat-label>
      <input type="number" matInput formControlName="sort" />
    </mat-form-field>
    @if (hasDescription()) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="app-field-description">
      <mat-label i18n>Description</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>
    }
    <button matButton="outlined" (click)="openCommentDialog()">
      <mat-icon>{{ comment ? commentTypeIcons[comment.type] : "add_comment" }}</mat-icon>
      @if (comment) {
        <span i18n>Edit comment</span>
      } @else {
        <span i18n>Add comment</span>
      }
    </button>
    <button matButton="outlined" (click)="delete()" i18n>Delete Field</button>
    }
  </div>
  @if (!isFormula()) {
  <div class="flex-row start-center app-values">
    @for (opt of getValues(itemForm()); track opt; let i = $index) {
    <div class="app-value">
      <span class="app-multi-label">
        @if (itemForm().controls.type.value === FieldTypes.RADIO) {
        <span><mat-icon>adjust</mat-icon></span>
        } @if (itemForm().controls.type.value === FieldTypes.MULTI) {
        <span><mat-icon>crop_square</mat-icon></span>
        } @if (itemForm().controls.type.value === FieldTypes.DROPDOWN) {
        <span><mat-icon>arrow_drop_down</mat-icon></span>
        }
        {{ opt.value }}
        <button matButton matSuffix aria-label="Clear" (click)="deleteValue(i)">
          <mat-icon class="cust-mat-icon">close</mat-icon>
        </button>
      </span>
    </div>
    }
    @if (hasNumericValues() && getValues(itemForm()).length > 0) {
      @let numbers = numericValuesSummary();
      <button
        matButton="outlined"
        type="button"
        (click)="editNumericValues()"
        [class.app-numeric-incomplete]="numericValuesIncomplete()"
        i18n-matTooltip="@@fieldNumericValuesTooltip"
        matTooltip="Numbers of the options, for formula fields"
      >
        <mat-icon>pin</mat-icon>
        <span i18n="@@fieldNumericValues">Numeric values</span>
        ({{ numbers.mapped }}/{{ numbers.total }})
      </button>
    }
  </div>
  }
  @if (isExpression()) {
  <div class="app-formula">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="app-formula-input">
      <mat-label i18n="@@fieldFormula">Formula</mat-label>
      <input
        matInput
        [formControl]="formulaControl"
        [errorStateMatcher]="expressionErrorMatcher"
        (input)="onFormulaChange($any($event.target).value)"
      />
      <!-- mat-error / mat-hint must be direct children to be projected below the field -->
      <mat-error>
        @for (msg of formulaControl.errors?.expressionSyntax ?? []; track msg) {
          <div>{{ msg }}</div>
        }
      </mat-error>
      <mat-hint [class.app-formula-warning]="formulaWarnings().length > 0">
        @for (msg of formulaWarnings(); track msg) {
          <div>{{ msg }}</div>
        } @empty {
          @if (attributesAvailable()) {
            <span i18n="@@fieldFormulaHintAttachment">Arguments: number fields, radio/dropdown fields with numeric values, numeric fixed attributes of the device's product (by key).</span>
          } @else {
            <span i18n="@@fieldFormulaHint">Arguments: number fields, radio/dropdown fields with numeric values. Device attributes only in attachment-only templates.</span>
          }
        }
      </mat-hint>
    </mat-form-field>
  </div>
  }
  @if (isCondition()) {
  <div class="app-formula">
    <button matButton="outlined" type="button" (click)="openConditionDialog()">
      <mat-icon>call_split</mat-icon>
      <span i18n="@@fieldEditCondition">Edit condition</span>
    </button>
    @if (conditionSummary(); as summary) {
      <span class="app-formula-summary">{{ summary }}</span>
    } @else {
      <span class="app-formula-summary app-formula-missing" i18n="@@fieldConditionMissing">No condition yet</span>
    }
  </div>
  }
</form>
<form [formGroup]="addGroup">
  <div
    class="app-add-value"
    [hidden]="
      itemForm().controls.type.value !== FieldTypes.RADIO &&
      itemForm().controls.type.value !== FieldTypes.MULTI &&
      itemForm().controls.type.value !== FieldTypes.DROPDOWN
    "
  >
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label i18n>Add Value</mat-label>
      <input matInput formControlName="addValue" />
    </mat-form-field>
    <button
      matIconButton
      (click)="addNewValue()"
      [disabled]="!addGroup.controls.addValue.value"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</form>
